__turbopack_context__.v({
  "button": "form-module-scss-module__t3OAJq__button",
  "button_container": "form-module-scss-module__t3OAJq__button_container",
  "container": "form-module-scss-module__t3OAJq__container",
  "form__description": "form-module-scss-module__t3OAJq__form__description",
  "form__info_text": "form-module-scss-module__t3OAJq__form__info_text",
  "form__title": "form-module-scss-module__t3OAJq__form__title",
  "form_container": "form-module-scss-module__t3OAJq__form_container",
  "guestForm__info__text": "form-module-scss-module__t3OAJq__guestForm__info__text",
  "guestForm__title": "form-module-scss-module__t3OAJq__guestForm__title",
  "heart": "form-module-scss-module__t3OAJq__heart",
});
